import api from "./client";

export const fetchAvailabilityCalendarMonth = async ({ siteId, month }) => {
  if (!siteId || !month) return { days: [] };
  const { data } = await api.get(`/reports/inverter-availability/calendar`, {
    params: { site_id: siteId, month },
  });
  return data;
};

export const checkAvailabilityRange = async ({ siteId, startDate, endDate }) => {
  const { data } = await api.get(`/reports/inverter-availability/status`, {
    params: {
      site_id: siteId,
      start_date: startDate,
      end_date: endDate,
    },
  });
  return data;
};

export const fetchAvailabilitySummary = async ({ siteId, startDate, endDate, grouping }) => {
  const params = new URLSearchParams({
    site_id: siteId,
    start_date: startDate,
    end_date: endDate,
    grouping,
  });
  const { data } = await api.get(`/reports/inverter-availability/summary?${params.toString()}`);
  return data;
};
